import React from "react";
import {
  Box,
  Grid,
  Typography,
  Stack,
  Button,
  Divider,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import { motion } from "framer-motion";
import corsanoLogo from "../../static/media/StrategicAllies/corsano_strategic.webp";
import corsanoBanner from "../../static/media/StrategicAllies/corsanobanner.webp";

const specialties = [
  "Laboratorio Clínico",
  "Ecografías",
  "Cardiología",
  "Medicina General",
  "Ginecología",
  "Urología",
  "Neurología",
  "Endocrinología",
  "Traumatología",
  "Gastroenterología",
  "Neumología",
  "Reumatología",
  "Nefrología",
  "Psiquiatría",
  "Nutrición",
];

const cardiologyBenefits = [
  "Consulta cardiológica",
  "Electrocardiograma",
  "Ecocardiograma",
  "Holter EKG",
  "MAPA - Ergometría",
];

export default function CorsanoPartner() {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { xs: 6, md: 9 },
        bgcolor: "#ffffff",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: { xs: "92%", md: "80%" },
          maxWidth: "1500px",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            position: "relative",
            borderRadius: { xs: "28px", md: "34px" },
            overflow: "hidden",
            background:
              "linear-gradient(135deg, #0f0f10 0%, #161616 32%, #2a0a0d 58%, #5f0008 78%, #111111 100%)",
            boxShadow: "0 32px 90px rgba(0,0,0,0.18)",
            border: "1px solid rgba(255,255,255,0.06)",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "radial-gradient(circle at top right, rgba(229,9,20,0.22) 0%, transparent 34%), radial-gradient(circle at bottom left, rgba(255,255,255,0.06) 0%, transparent 28%)",
              pointerEvents: "none",
            }}
          />

          <Grid container>
            <Grid item xs={12} md={4.2} lg={4}>
              <Box
                sx={{
                  height: "100%",
                  px: { xs: 2.2, sm: 3, md: 3, lg: 6 },
                  pt: { xs: 3, md: 3.6 },
                  pb: { xs: 2.2, md: 3.2 },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <Stack
                  spacing={2.4}
                  sx={{
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <motion.img
                    src={corsanoLogo}
                    alt="Corsano"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.35 }}
                    transition={{ duration: 0.6 }}
                    style={{
                      width: "100%",
                      maxWidth: "220px",
                      display: "block",
                      filter: "drop-shadow(0 12px 24px rgba(0,0,0,0.18))",
                    }}
                  />

                  <Stack spacing={1.4} sx={{ maxWidth: 430 }}>
                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.82)",
                        lineHeight: 1.72,
                        fontSize: { xs: 14.5, md: 15.5 },
                      }}
                    >
                      El Centro de Especialidades Médicas y Laboratorio Clínico
                      CORSANO ofrece un 15% de descuento en servicios
                      cardiológicos para los miembros con membresía activa de NovaXFit.
                    </Typography>

                    <Typography
                      sx={{
                        color: "#fff",
                        fontWeight: 800,
                        letterSpacing: -0.6,
                        fontSize: { xs: 20, md: 23 },
                        mb: 1.2,
                        mt: 0.8,
                      }}
                    >
                      Beneficios incluidos
                    </Typography>

                    <Stack spacing={1.2}>
                      {cardiologyBenefits.map((item) => (
                        <Box
                          key={item}
                          sx={{
                            borderRadius: "16px",
                            px: 1.4,
                            py: 1.15,
                            background: "rgba(255,255,255,0.05)",
                            border: "1px solid rgba(255,255,255,0.08)",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#ffffff",
                              fontSize: { xs: 14, md: 14.8 },
                              fontWeight: 700,
                              lineHeight: 1.35,
                            }}
                          >
                            {item}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>
                  </Stack>
                </Stack>
                <Stack
                  direction="row"
                  spacing={1.6}
                  sx={{
                    mt: { xs: 0.6, md: 1 },
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  <motion.div
                    whileHover={{ scale: 1.04, y: -2 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Button
                      component="a"
                      href="https://www.instagram.com/dr.joseadames?igsh=MTdiZm94aGJtNXllbQ=="
                      target="_blank"
                      rel="noopener noreferrer"
                      endIcon={<InstagramIcon />}
                      sx={{
                        minHeight: 48,
                        textTransform: "none",
                        fontWeight: 800,
                        borderRadius: "16px",
                        px: 3,
                        fontSize: 14.5,
                        width: "fit-content",
                        color: "#ffffff",
                        background:
                          "linear-gradient(135deg, #5f0008 0%, #a80d19 38%, #df2632 68%, #161616 100%)",
                        boxShadow: "0 16px 35px rgba(229,9,20,0.25)",
                        "&:hover": {
                          filter: "brightness(1.05)",
                        },
                      }}
                    >
                      Instagram
                    </Button>
                  </motion.div>

                  <motion.div
                    whileHover={{ scale: 1.04, y: -2 }}
                    whileTap={{ scale: 0.98 }}
                  >
                  <Button
                    component="a"
                    href="https://wa.me/593997358076?text=Hola,%20quiero%20solicitar%20más%20información"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      minHeight: 48,
                      textTransform: "none",
                      fontWeight: 800,
                      borderRadius: "16px",
                      px: 3,
                      fontSize: 14.5,
                      width: "fit-content",
                      color: "#ffffff",
                      border: "1px solid rgba(255,255,255,0.14)",
                      background: "rgba(255,255,255,0.04)",
                      backdropFilter: "blur(8px)",
                      "&:hover": {
                        background: "rgba(255,255,255,0.08)",
                        borderColor: "rgba(255,77,87,0.34)",
                      },
                    }}
                  >
                    099 735 8076
                  </Button>
                  </motion.div>
                </Stack>
              </Box>
            </Grid>

            <Grid item xs={12} md={7.8} lg={8}>
                <Box
                  sx={{
                    height: "100%",
                    px: { xs: 2.2, sm: 3, md: 3.2, lg: 6 },
                    pt: { xs: 0, md: 3.4 },
                    pb: { xs: 3, md: 3.4 },
                    position: "relative",
                    zIndex: 1,

                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                <motion.img
                  src={corsanoBanner}
                  alt="Servicios Corsano"
                  initial={{ opacity: 0, y: 28 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.7 }}
                  style={{
                    width: "100%",
                    maxWidth: "550px",
                    display: "block",
                    margin: "0 auto",
                    borderRadius: "24px",
                    boxShadow: "0 24px 60px rgba(0,0,0,0.22)",
                  }}
                />

                <Grid
                  container
                  spacing={{ xs: 2.2, md: 2.6 }}
                  sx={{ mt: { xs: 2.6, md: 3 } }}
                >
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        height: "100%",
                        width: "100%",
                        borderRadius: "24px",
                        p: { xs: 2.2, md: 2.6 },
                        background: "rgba(255,255,255,0.06)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        backdropFilter: "blur(10px)",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#ffffff",
                          fontWeight: 800,
                          letterSpacing: -0.6,
                          fontSize: { xs: 20, md: 23 },
                          mb: 2,
                        }}
                      >
                        Especialidades médicas
                      </Typography>

                      <Grid container columnSpacing={{ xs: 2, md: 3 }} rowSpacing={1.15}>
                        {[
                          specialties.slice(0, 4),
                          specialties.slice(4, 8),
                          specialties.slice(8, 12),
                          specialties.slice(12),
                        ].map((group, index) => (
                          <Grid item xs={6} md={3} key={index}>
                            <Stack spacing={1.05}>
                              {group.map((item) => (
                                <Typography
                                  key={item}
                                  sx={{
                                    color: "rgba(255,255,255,0.86)",
                                    fontSize: { xs: 13.6, md: 14.4, lg: 14.8 },
                                    fontWeight: 700,
                                    lineHeight: 1.45,
                                  }}
                                >
                                  {item}
                                </Typography>
                              ))}
                            </Stack>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            mt: { xs: 3.2, md: 4 },
            borderRadius: { xs: "24px", md: "30px" },
            background: "#ffffff",
            border: "1px solid rgba(17,17,17,0.08)",
            boxShadow: "0 18px 48px rgba(0,0,0,0.07)",
            px: { xs: 2.2, md: 3.2 },
            py: { xs: 2.3, md: 2.8 },
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 2, md: 3 }}
            divider={
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  display: { xs: "none", md: "block" },
                  borderColor: "rgba(17,17,17,0.08)",
                }}
              />
            }
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#111111",
                  fontWeight: 900,
                  fontSize: { xs: 18, md: 19 },
                  mb: 1,
                }}
              >
                Términos y condiciones
              </Typography>

              <Stack spacing={0.85}>
                <Typography
                  sx={{
                    color: "rgba(17,17,17,0.74)",
                    fontSize: { xs: 14.2, md: 14.7 },
                    fontWeight: 700,
                    lineHeight: 1.5,
                  }}
                >
                  Aplica únicamente para miembros con membresía activa de NovaXFit.
                </Typography>

                <Typography
                  sx={{
                    color: "rgba(17,17,17,0.74)",
                    fontSize: { xs: 14.2, md: 14.7 },
                    fontWeight: 700,
                    lineHeight: 1.5,
                  }}
                >
                  El descuento es válido en todos los servicios cardiológicos
                  detallados.
                </Typography>
              </Stack>
            </Box>

            <Box
              sx={{
                minWidth: { xs: "auto", md: 250 },
                display: "flex",
                alignItems: { xs: "flex-start", md: "center" },
              }}
            >
              <Button
                component="a"
                href="https://www.instagram.com/dr.joseadames?igsh=MTdiZm94aGJtNXllbQ=="
                target="_blank"
                rel="noopener noreferrer"
                endIcon={<ArrowOutwardRoundedIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 900,
                  borderRadius: "14px",
                  px: 2.4,
                  py: 1.1,
                  fontSize: 14.5,
                  color: "#111111",
                  bgcolor: "#f7f7f7",
                  border: "1px solid rgba(17,17,17,0.08)",
                  "&:hover": {
                    bgcolor: "#f1f1f1",
                  },
                }}
              >
                Ver contacto
              </Button>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}